import script from "./MediaGalleryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaGalleryPage.vue?vue&type=script&setup=true&lang=js"

import "./MediaGalleryPage.vue?vue&type=style&index=0&id=f0e4944a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0e4944a"]])

export default __exports__